var React = require('react');

function AnimatedTick (props) {
    return React.createElement("svg",props,[React.createElement("path",{"className":"circ path","style":{"fill":"none","strokeWidth":"3","strokeLinejoin":"round","strokeMiterlimit":"10"},"d":"\n\tM30.5,6.5L30.5,6.5c6.6,6.6,6.6,17.4,0,24l0,0c-6.6,6.6-17.4,6.6-24,0l0,0c-6.6-6.6-6.6-17.4,0-24l0,0C13.1-0.2,23.9-0.2,30.5,6.5z","key":0}),React.createElement("polyline",{"className":"tick path","style":{"fill":"none","strokeWidth":"3","strokeLinejoin":"round","strokeMiterlimit":"10"},"points":"\n\t11.6,20 15.9,24.2 26.4,13.8 ","key":1})]);
}

AnimatedTick.defaultProps = {"version":"1.1","id":"tick","x":"0px","y":"0px","viewBox":"0 0 37 37","style":{"enableBackground":"new 0 0 37 37"},"xmlSpace":"preserve"};

module.exports = AnimatedTick;

AnimatedTick.default = AnimatedTick;
